import axios from 'axios';
const state = {
  ccg: [],
};
import config from '@/../config';
const defaultErrorHandler = error => Promise.reject(error.response);

const mutations = {
  SET_CCG(state, payload) {
    state.ccg = payload;
  },
};

const actions = {
  async INSERT_CCG_PERSON({ commit }, payload) {
    let response = await axios.post(
      config.apiUrl +
        config.versoes[0] +
        `/tomador-corretor/${payload.idTomador}/fiador-ccg`,
      payload.pessoa
    );
    commit('SET_CCG', response.data);
    return response.data;
  },

  async GET_CCG_PEOPLE({ commit }, payload) {
    // let response = await axios.get(config.apiUrl + config.versoes[0]+ `tomador/${payload.documento}/fiador-ccg`)
    let response = await axios.get(
      config.apiUrl +
        config.versoes[0] +
        `/tomador-corretor/${payload.documento}/fiador-ccg`
    );
    commit('SET_CCG', response.data);
    return response.data;
  },
  
  async SIGN_CCG({ commit }, payload) {
    // let response = await axios.get(config.apiUrl + config.versoes[0]+ `tomador/${payload.documento}/fiador-ccg`)
    let response = await axios.get(
      config.apiUrl +
        config.versoes[0] +
        `/tomador-corretor/${payload.documento}/documento-ccg`
    );

    return response.data;
  },

  async UPDATE_CCG_EMAIL({ commit }, payload) {
    let response = await axios.patch(
      config.apiUrl +
        config.versoes[0] +
        `/tomador-corretor/${payload.idTomador}/fiador-ccg`,
      payload.pessoa
    );
    commit('SET_CCG', response.data);
    return response.data;
  },

  //http://localhost:5000/api/v1/
  async GET_CCG_DOCUMENTO({ commit }, payload) {
    // let response = await axios.get(config.apiUrl + config.versoes[0]+ `tomador/${payload.documento}/fiador-ccg`)
    let response = await axios.get(
      config.apiUrl +
        config.versoes[0] +`/propostaTomador/${payload.cnpj}/documentoCCG`
    );

    return response.data;
  },
};

export default {
  state,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/ccg.js